module.exports = __webpack_public_path__ + "img/album10_03.3b2f1bea.jpg";